// extracted by mini-css-extract-plugin
export default {"btn_group":"ToggleLang_btn_group__E8t1z","btn_lang":"ToggleLang_btn_lang__FLxjI","active":"ToggleLang_active__d+wPY"};